<template>
  <pagefra>
    <div class="elevtorVideoLog container">
      <panel type="toolbar">
        <div class="toolbar">
          <el-form
            class="toolbar-form"
            :inline="true"
            v-model="form"
            label-width
          >
            <el-form-item :label="$l('电梯工号')">
              <el-input
                v-model="form.jobNum"
                :placeholder="$l('电梯工号')"
              ></el-input>
            </el-form-item>
            <el-form-item :label="$l('设备号')">
              <el-input
                v-model="form.deviceSerial"
                :placeholder="$l('设备号')"
              ></el-input>
            </el-form-item>
            <el-form-item :label="$l('用户')">
              <el-input
                v-model="form.username"
                :placeholder="$l('用户')"
              ></el-input>
            </el-form-item>
            <el-form-item :label="$l('请求页面')">
              <el-input
                v-model="form.pageInfo"
                :placeholder="$l('请求页面')"
              ></el-input>
            </el-form-item>
            <el-form-item :label="$l('是否警告')">
              <el-select v-model="form.hasWarn" :placeholder="$l('是否警告')">
                <el-option :label="$l('是否警告')" value=""></el-option>
                <el-option :label="$l('是')" value="1"></el-option>
                <el-option :label="$l('否')" value="0"></el-option>
              </el-select>
            </el-form-item>
            <el-form-item :label="$l('记录时间')">
              <el-date-picker
                v-model="recordTimeValues"
                type="datetimerange"
                :range-separator="$l('至')"
                :start-placeholder="$l('记录开始时间')"
                :end-placeholder="$l('记录结束时间')"
              >
              </el-date-picker>
            </el-form-item>
            <el-form-item>
              <el-button
                icon="el-icon-search"
                type="primary"
                circle
                @click="search"
              ></el-button>
            </el-form-item>
          </el-form>
          <div class="toolbar-btn">
            <el-button
              round
              icon="el-icon-download"
              @click="exportLog"
              v-if="hasPermission('导出')"
              >{{ $l("导出") }}
            </el-button>
          </div>
        </div>
      </panel>
      <panel class="panel-table">
        <div class="panel-table__table">
          <el-table
            ref="filterTable"
            size="medium"
            tooltip-effect="tableTooltip"
            highlight-current-row
            height="100%"
            v-loading.lock="loading"
            :data="tableData"
            style="width: 100%; z-index: 1000"
          >
            <el-table-column
              type="index"
              :label="$l('序号')"
              width="80"
              align="center"
            ></el-table-column>
            <el-table-column
              :label="$l('电梯工号')"
              prop="jobNum"
              align="center"
              min-width="120"
            ></el-table-column>
            <el-table-column
              :label="$l('设备号')"
              prop="deviceSerial"
              align="center"
              width="120"
            ></el-table-column>
            <!-- <el-table-column
              :label="$l('设备名称')"
              prop="deviceName"
              align="center"
              width="200"
            ></el-table-column> -->
            <el-table-column
              :label="$l('用户')"
              prop="username"
              align="center"
              width="120"
            ></el-table-column>
            <el-table-column
              :label="$l('事件信息')"
              prop="eventInfo"
              align="center"
              width="120"
            ></el-table-column>
            <el-table-column
              :label="$l('是否警告')"
              prop="hasWarrn"
              align="center"
              width="120"
              :formatter="hasWarnFormatter"
            ></el-table-column>
            <el-table-column
              :label="$l('请求页面')"
              prop="pageInfo"
              align="center"
              width="120"
            ></el-table-column>
            <el-table-column
              :label="$l('记录时间')"
              prop="recordTime"
              align="center"
              width="200"
            ></el-table-column>
          </el-table>
        </div>
        <el-pagination
          :current-page="pageConfig.currentPage"
          :page-sizes="pageConfig.pageSizes"
          :page-size="pageConfig.pageSize"
          :total="pageConfig.total"
          @size-change="handlePageSizeChange"
          @current-change="handleCurrentPageChange"
          layout="total, sizes, prev, pager, next, jumper"
        ></el-pagination>
      </panel>
    </div>
  </pagefra>
</template>

<script>
// @ is an alias to /src
import panel from "@/components/panel.vue";
import global from "@/mixins/global.js";
export default {
  name: "elevtorVideoLog",
  mixins: [global],
  components: {
    panel,
  },
  props: {
    loaded: {
      type: Boolean,
      default: true,
    },
  },
  data() {
    return {
      form: {
        jobNum: "",
        deviceSerial: "",
        username: "",
        hasWarn: "",
        pageInfo: "",
        startRecordTime: null,
        endRecordTime: null,
      },
      tableData: [],
      loading: false,
      recordTimeValues: [],
    };
  },
  mounted() {
    if (this.loaded) {
      this.initData();
    }
  },
  methods: {
    handlePageSizeChange(val) {
      this.pageConfig.pageSize = val;
      this.initData();
    },
    handleCurrentPageChange(val) {
      this.pageConfig.currentPage = val;
      this.initData();
    },
    search() {
      this.pageConfig.currentPage = 1;
      this.initData();
    },
    initData() {
      const dataListCacheKey = this.$options.name + "_data_list";
      const dataTotalCacheKey = this.$options.name + "_data_total";
      if (this.$store.state.pageScroll.scroll) {
        const json = sessionStorage.getItem(dataListCacheKey);
        if (json) {
          this.tableData = JSON.parse(json);
          this.pageConfig.total = parseInt(
            sessionStorage.getItem(dataTotalCacheKey)
          );
          sessionStorage.removeItem(dataTotalCacheKey);
          sessionStorage.removeItem(dataListCacheKey);
          return;
        }
      }
      this.form.pageNum = this.pageConfig.currentPage;
      this.form.pageSize = this.pageConfig.pageSize;
      if (this.recordTimeValues && this.recordTimeValues.length == 2) {
        this.form.startRecordTime = this.$common.formatDateTime(
          this.recordTimeValues[0]
        );
        this.form.endRecordTime = this.$common.formatDateTime(
          this.recordTimeValues[1]
        );
      } else {
        this.form.startRecordTime = null;
        this.form.endRecordTime = null;
      }
      this.tableData = [];
      this.loading = true;
      this.$http
        .get(this.$apiConfig.search_elevator_video_log_url, {
          params: this.form,
        })
        .then((response) => {
          this.loading = false;
          let result = response.data;
          if (result.code == 0) {
            this.pageConfig.total = result.data.total;
            this.tableData = result.data.result;
            if (
              !this.loaded &&
              this.$store.state.pageScroll.scroll &&
              !sessionStorage.getItem(dataListCacheKey)
            ) {
              sessionStorage.setItem(dataTotalCacheKey, this.pageConfig.total);
              sessionStorage.setItem(
                dataListCacheKey,
                JSON.stringify(this.tableData)
              );
            }
          } else {
            this.message(result.code, result.msg);
          }
        })
        .catch((error) => {
          this.loading = false;
          this.errorMessage();
          this.$sentry.captureException(error);
        });
    },
    hasWarnFormatter(row) {
      if (row.hasWarn) {
        return "是";
      } else {
        return "否";
      }
    },
    exportLog() {
      if (this.recordTimeValues && this.recordTimeValues.length == 2) {
        this.form.startRecordTime = this.$common.formatDateTime(
          this.recordTimeValues[0]
        );
        this.form.endRecordTime = this.$common.formatDateTime(
          this.recordTimeValues[1]
        );
      } else {
        this.form.startRecordTime = null;
        this.form.endRecordTime = null;
      }
      this.fullLoading = true;
      let filename =
        "视频日志管理表_" + this.$common.formatCurrentDateTime(false) + ".xlsx";
      this.$http({
        url: this.$apiConfig.export_elevator_video_log_url,
        method: "post",
        responseType: "blob",
        data: this.form,
      })
        .then((response) => {
          this.fullLoading = false;
          const status = response.status;
          if (status != 200) {
            this.message(
              1,
              status == 201
                ? "导出失败"
                : status == 202
                ? "没有数据"
                : "数据量过大"
            );
            return;
          }
          const data = response.data;
          var blob = new Blob([data]);
          //判断是不是ie的浏览器
          if (!!window.ActiveXObject || "ActiveXObject" in window) {
            window.navigator.msSaveOrOpenBlob(blob, filename);
          } else {
            var url = window.URL.createObjectURL(blob);
            var aLink = document.createElement("a");
            aLink.style.display = "none";
            aLink.download = filename;
            aLink.href = url;
            document.body.appendChild(aLink);
            aLink.click();
            document.body.removeChild(aLink); // 下载完成移除元素
            window.URL.revokeObjectURL(url); // 释放掉blob对象
          }
        })
        .catch((error) => {
          this.fullLoading = false;
          this.errorMessage(0);
          this.$sentry.captureException(error);
        });
    },
  },
};
</script>
<style lang="scss" scoped>
.elevtorVideoLog {
}
</style>
